import React from "react"

import { Grid } from "@mui/material"

import { UseFormReturn } from "react-hook-form"

import { MatesDatePicker, MatesSelect, MatesTextField, withUseFormHook } from "@sinossi/mates-react-library"

import { AdvancedSearchbar } from "components/advanced-searchbar/advanced-searchbar"

import ActionsAdvancedSearchValidation, { ActionsAdvancedSearchForm } from "./form"
import { ActionsRequest, ActionStatus, WorkflowStepType } from "../../../models"
import { t, Trans } from "@lingui/macro"

interface ActionsAdvancedSearchProps extends UseFormReturn {
    handleCallback: (data: ActionsRequest) => void
}
class ActionsAdvancedSearch extends React.Component<ActionsAdvancedSearchProps, {}> {
    public componentDidMount() {
    }

    private onSearch = (data: Record<string, any>): void => {
        const formData: ActionsAdvancedSearchForm = new ActionsAdvancedSearchForm()
        Object.assign(formData, data)

        const request: ActionsRequest = formData.toRequest()
        this.props.handleCallback(request)
    }

    render() {
        return (
            <AdvancedSearchbar
                {...this.props}
                searchFieldName="executor"
                searchFieldPlaceholder="Ricerca per esecutore azione"
                onSearch={this.onSearch}>
                <Grid container spacing={2}>
                    <Grid item md={8}>
                        <MatesTextField
                            name="executor"
                            label="Esecutore"
                            variant="outlined"
                            control={this.props.control}
                            trigger={this.props.trigger}
                            formState={this.props.formState} />
                    </Grid>
                    <Grid item md={4}>
                        <MatesSelect
                            name="actionType"
                            label="Tipo di azione"
                            variant="outlined"
                            formState={this.props.formState}
                            control={this.props.control}
                            trigger={this.props.trigger}>
                            {Object.keys(WorkflowStepType).map((typeKey, index) =>
                                <option value={typeKey} key={index}>
                                    <Trans id={`enums.workflow-step-types.${typeKey}`}>
                                    </Trans>
                                </option>
                            )}
                        </MatesSelect>
                    </Grid>
                    <Grid item md={4}>
                        <MatesSelect
                            name="actionStatus"
                            label="Stato azione"
                            variant="outlined"
                            formState={this.props.formState}
                            control={this.props.control}
                            trigger={this.props.trigger}>
                            {Object.keys(ActionStatus).map((typeKey, index) =>
                                <option value={typeKey} key={index}>
                                    <Trans id={`enums.action-status.${typeKey}`}>
                                    </Trans>
                                </option>
                            )}
                        </MatesSelect>
                    </Grid>
                    <Grid item md={4}>
                        <MatesDatePicker variant="outlined"
                            label={t({
                                id: "actions-advanced-search.start-date",
                                message: "Data inizio",
                            })}
                            name="startDate"
                            control={this.props.control}
                            trigger={this.props.trigger}
                            formState={this.props.formState}
                        />
                    </Grid>
                    <Grid item md={4}>
                        <MatesDatePicker variant="outlined"
                            label={t({
                                id: "actions-advanced-search.end-date",
                                message: "Data fine",
                            })}
                            name="endDate"
                            control={this.props.control}
                            trigger={this.props.trigger}
                            formState={this.props.formState}
                        />
                    </Grid>
                </Grid>
            </AdvancedSearchbar>
        )
    }
}

export default withUseFormHook<ActionsAdvancedSearchForm>(
    ActionsAdvancedSearch,
    ActionsAdvancedSearchValidation,
    new ActionsAdvancedSearchForm()
)
